import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { reduxForm, getFormValues } from 'redux-form';
import withStyles from 'housecall-ui/dist/DesignSystem/Styles/withStyles';
import Button from 'housecall-ui/dist/DesignSystem/Inputs/Buttons/Button'
import Dialog from 'housecall-ui/dist/DesignSystem/Feedback/Dialog/Dialog'
import withMobileDialog from 'housecall-ui/dist/DesignSystem/Feedback/Dialog/withMobileDialog'
import DialogActions from 'housecall-ui/dist/DesignSystem/Feedback/Dialog/DialogActions'
import DialogContent from 'housecall-ui/dist/DesignSystem/Feedback/Dialog/DialogContent'
import DialogTitle from 'housecall-ui/dist/DesignSystem/Feedback/Dialog/DialogTitle'
import Grid from "housecall-ui/dist/DesignSystem/Layout/Grid/Grid"
import ParentComponentSpinner from "../../Common/MaterialUiExtended/Spinner/ParentComponentSpinner.jsx"
import ContactInfoFormContent from './ContactInfoFormContent.jsx';
import Divider from "housecall-ui/dist/DesignSystem/DataDisplay/Divider/Divider"
import CustomerDetailsFormContent from './CustomerDetailsFormContent.jsx';
import AddressesFormContent from './AddressesFormContent.jsx';
import FormControlLabel from 'housecall-ui/dist/DesignSystem/Inputs/FormControls/FormControlLabel'
import FormCheckbox from 'components/Common/Inputs/FormControls/FormCheckbox'
import FullWidthDialogActions from "../../Common/MaterialUiExtended/Dialog/FullWidthDialogActions.jsx";
import { onSubmit, CUSTOMER_INFO_FORM, validate, clearCustomerInitialFields } from './Redux/Actions';
import WisetackPrequalCheckbox from 'components/Customers/AddOrEditCustomer/WisetackPrequalCheckbox';

const styles = theme => ({
    dialogContent: {
        height: 'calc(100% - 225px)',
        borderBottom: `solid 1px ${theme.palette.borderColor}`,
    },
    formControl: {
        margin: 0
    }
})

@connect(
    state => ({
        initialValues: state?.addOrEditCustomer?.initialValues
    }),
    dispatch => ({
        clearCustomerInitialFields: () => {
            dispatch(clearCustomerInitialFields())
        }
    })
)

@reduxForm({
    form: CUSTOMER_INFO_FORM,
    enableReinitialize: true,
    onSubmit,
    validate
})

@withMobileDialog()
@withStyles(styles)
export default class CustomerForm extends PureComponent {
    constructor(props) {
      super(props)
      this.state = {
        showSpinner: false
      }
    }

    showSpinner() {
      this.setState({ showSpinner: true })
    }

    render() {
        const {classes, fullScreen, submitting, pristine, dirty, onSubmit, action} = this.props
        const spinner =
          <Grid>
            <ParentComponentSpinner showSpinner={submitting}/>
          </Grid>

        return (
            <form onSubmit={onSubmit}>
                <Dialog
                    maxWidth={'xl'}
                    fullScreen={fullScreen}
                    open={this.props.openDialog}
                    onClose={this.props.closeDialog}
                >
                  <React.Fragment>
                    {spinner}
                      <DialogTitle>
                        {this.props.title}
                      </DialogTitle>
                      <DialogContent className={classes.dialogContent}>
                        <Grid container direction='column' spacing={24}>
                          <Grid item>
                            <ContactInfoFormContent formNamespace={CUSTOMER_INFO_FORM}/>
                          </Grid>
                          <Grid item>
                            <Divider/>
                          </Grid>
                          <Grid item>
                            <AddressesFormContent/>
                          </Grid>
                          <Grid item>
                            <Divider/>
                          </Grid>
                          <Grid item>
                            <CustomerDetailsFormContent/>
                          </Grid>
                        </Grid>
                      </DialogContent>
                      <Divider/>
                      <FullWidthDialogActions
                        leftComponent={
                          <Grid container spacing={3} alignItems="flex-start">
                            <Grid item>
                              <FormControlLabel
                                className={classes.formControl}
                                control={
                                  <FormCheckbox
                                    name="notifications_enabled"
                                    disabled={this.props.disabled}
                                  />
                                }
                                label="Send notifications"
                              />
                            </Grid>
                            { action === 'create' &&
                              <Grid item>
                                <WisetackPrequalCheckbox />
                              </Grid>
                            }
                          </Grid>
                        }
                        rightComponent={
                          <DialogActions>
                            <Button
                              onClick={() => {this.props.close(dirty)}}
                            >
                              Cancel
                            </Button>
                            <Button
                              type={'submit'}
                              onClick={this.props.handleSubmit}
                              color="primary"
                              disabled={pristine || submitting}
                            >
                              {this.props.action} customer
                            </Button>
                          </DialogActions>
                        }
                      />
                    </React.Fragment>
                </Dialog>
            </form>
        )
    }
}
